import React, { useState, useEffect } from 'react'
import useDecodedToken from '../../features/utils/hooks/useDecodedToken';
import { useDispatch } from 'react-redux';
import { Button } from 'react-bootstrap';
import { updateDetails } from '../../features/auth/authSlice'

import { toast } from "react-toastify";;

const Setting = () => {
  const [errors, setErrors] = useState("");
  const [errorData, setErrorData] = useState([]);
  const [loginError, setLoginError] = useState("");
  const decodedToken = useDecodedToken();
  const [newPassword, setnewShowPassword] = useState(false);
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    try {
      const updateData = {
        email: formData.email,
        password: formData.password,
      };

      dispatch(updateDetails(updateData))
        .unwrap()
        .then((result) => {
          console.log(result);
          if (result.status) {
            toast.success(result.message, {
              
            });
            setFormData({
              email: "",
              password: ""
            });
          } else {
            setLoginError(result.message);
            setErrorData(result.form_err);
          }
        })
        .catch((err) => {
          setLoginError(err.message);
          setErrorData(err.form_err || []);
          toast.error(err.message);
        });
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  const mapErrors = (errorData) => {
    const errorMap = {};
    errorData.forEach((error) => {
      if (!errorMap[error.param]) {
        errorMap[error.param] = error.msg;
      }
    });
    return errorMap;
  };
  useEffect(() => {
    const errorsValue = mapErrors(errorData);
    setErrors(errorsValue);
  }, [errorData]);

 
  const handleToggleNewPassword = () => {
    setnewShowPassword(!newPassword);
  };

  useEffect( () => {
    console.log("errors msg ==>", errors);
    
  }, [errors])

  return (
    <>
      <div className="row justify-content-center">
      <div className="col-sm-12">
        <div className="row">
          <div className="col-sm-12">
            <h4 className='text-center'>Setting</h4>
          </div>
        </div>
      </div>

      <div className="col-md-12 col-lg-12 col-xl-6">
        <div className="card">
          <div className="card-body">
            <table className="table table-striped table-bordered">
              <tbody>
                <tr>
                  <td className="w-25 p-3">Email ID:</td>
                  <td>
                    <div className="position-relative mb-3">
                      <input
                        type="text"
                        className="form-control pe-5"
                        name="email"
                        placeholder="Enter Email id"
                        value={formData.email}
                        onChange={handleChange}
                        autoComplete="off"
                      />                      

                      {errors.email && (
                        <div className="text-danger">{errors.email}</div>
                      )}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="p-3">Password:</td>
                  <td>
                    <div className="position-relative mb-3">
                      <input
                        type={newPassword ? "text" : "password"}
                        className="form-control pe-5"
                        name="password"
                        placeholder="Enter Password"
                        value={formData.password}
                        onChange={handleChange}
                        autoComplete="off"
                      />

                      <button
                        type="button"
                        className="btn btn-link position-absolute end-0 top-0 text-muted"
                        onClick={handleToggleNewPassword}
                      >
                        <i className={`ri-${newPassword ? "eye-off-fill" : "eye-fill"}`}></i>
                      </button>

                      {errors.password && (
                        <div className="text-danger">{errors.password}</div>
                      )}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="d-flex justify-content-end">
              <Button
                      variant="primary"
                      onClick={handleSubmit}
                      disabled={
                        !formData.email ||
                        !formData.password
                      }
                    >
                      Update
                    </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default Setting
